import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {connect} from 'react-redux'
import {change} from 'redux-form'
import moment from 'moment'
import {scroller} from 'react-scroll'
import SostaOnlineApiService from '../services/SostaOnlineApiService'
import BackOfficeUserDetailScreen from '../screens/BackOfficeUserDetailScreen'
import queryString from 'query-string'

const fileDownload = require('js-file-download')

moment.locale('it')
const mapStateToProps = (state) => {
  return {
    state: state.users
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch
  }
}

class BackOfficeUserDetailContainer extends Component {
  static propTypes = {
  }

  constructor (props) {
    super(props)
    this.state = {
      loading: false,
      userId: props.match.params.id,
      addresses: [],
      userType: {},
      userTypes: [],
      areas: [],
      parkingPassTypes: [],
      user: {},
      markTypes: [],
      parkTicketTypes: [],
      vehicleLoading: false,
      vehicleError: null,
      vehicleSuccess: false,
      markLoading: false,
      markError: null,
      markSuccess: false,
      parkTicketLoading: false,
      parkTicketError: null,
      parkTicketSuccess: false,
      receiptLoading: false,
      receiptError: null,
      receiptSuccess: false,
      vehiclesEditsResults: {},
      vehiclesDeleteResults: {},
      marksDeleteResults: {},
      marksCeaseResults: {},
      markActivateErrors: {},
      marksNotesAddedResults: {},
      registry: {},
      reviewingMark: null,
      showReviewDocumentsModal: false,
      submittingMarkEdit: false,
      highlightObjects: [],
      renewPaymentMethodSelected: '',
      markRenewing: {},
      markRenewingErrors: {},
      userAdjustment: null,
      merger: null,
      merging: false,
      userWaitingLists: []
    }

    this.onDeleteVehicle = this.onDeleteVehicle.bind(this)
    this.onVehicleSubmit = this.onVehicleSubmit.bind(this)
    this.onCloseVehicleEdit = this.onCloseVehicleEdit.bind(this)
    this.onEditVehicleSubmit = this.onEditVehicleSubmit.bind(this)
    this.onMarkSubmit = this.onMarkSubmit.bind(this)
    this.onDeleteMark = this.onDeleteMark.bind(this)
    this.onCeaseMark = this.onCeaseMark.bind(this)
    this.onCloseMarkCease = this.onCloseMarkCease.bind(this)
    this.onParkingPassSubmit = this.onParkingPassSubmit.bind(this)
    this.onCreateMarkUserCategorySelected = this.onCreateMarkUserCategorySelected.bind(this)
    this.onDownloadParkTicket = this.onDownloadParkTicket.bind(this)
    this.onDownloadMark = this.onDownloadMark.bind(this)
    this.onDownloadMarkRelease = this.onDownloadMarkRelease.bind(this)
    this.onDownloadUserCredentials = this.onDownloadUserCredentials.bind(this)
    this.onReceiptDownload = this.onReceiptDownload.bind(this)
    this.onMarkReceiptDownload = this.onMarkReceiptDownload.bind(this)
    this.onIssueReceipt = this.onIssueReceipt.bind(this)
    this.onEditProfileClick = this.onEditProfileClick.bind(this)
    this.onMarkActivateClick = this.onMarkActivateClick.bind(this)
    this.onDenyMarkActivationClick = this.onDenyMarkActivationClick.bind(this)
    this.onListAsWaitConfirm = this.onListAsWaitConfirm.bind(this)
    this.onCloseWaitConfirm = this.onCloseWaitConfirm.bind(this)
    this.onOpenReviewDocumentsModal = this.onOpenReviewDocumentsModal.bind(this)
    this.onCloseReviewDocumentsModal = this.onCloseReviewDocumentsModal.bind(this)
    this.onApprovationChanged = this.onApprovationChanged.bind(this)
    this.onMarkEditSubmit = this.onMarkEditSubmit.bind(this)
    this.onMarkShortLinkClick = this.onMarkShortLinkClick.bind(this)
    this.onMarkRenew = this.onMarkRenew.bind(this)
    this.onRenewPaymentMethodChange = this.onRenewPaymentMethodChange.bind(this)
    this.onRenewMarkClick = this.onRenewMarkClick.bind(this)
    this.onCancelRenewMarkClick = this.onCancelRenewMarkClick.bind(this)
    this.fetchAdjustment = this.fetchAdjustment.bind(this)
    this.onAdjustmentPay = this.onAdjustmentPay.bind(this)
    this.onAdjustmentDownloadReceipt = this.onAdjustmentDownloadReceipt.bind(this)
    this.fetchMerger = this.fetchMerger.bind(this)
    this.acceptMerge = this.acceptMerge.bind(this)
    this.denyMerge = this.denyMerge.bind(this)
  }

  async componentDidMount () {
    await Promise.all([
      this.fetchUser(),
      this.fetchAreas(),
      // this.fetchUserTypes();
      // this.fetchParkingPassTypes();
      this.fetchParkTicketTypes(),
      this.fetchAddresses(),
      this.fetchUserCompletedWaitingLists()
    ])

    const queryParams = queryString.parse(this.props.location.search)
    if (queryParams.scrollTo) {
      setTimeout(() => {
        this.scrollTo(queryParams.scrollTo)
        this.highlightElement(queryParams.scrollTo)
      }, 300)
    }
  }

  async fetchAdjustment (fiscalCode, vatNumber) {
    try {
      const res = await SostaOnlineApiService.fetchAdjustment(fiscalCode, vatNumber)
      this.setState({userAdjustment: res.data})
    } catch (err) {
      console.error(err)
    }
  }

  async fetchMerger (fiscalCode) {
    try {
      const res = await SostaOnlineApiService.fetchMerge(fiscalCode)
      this.setState({merger: res.data})
    } catch (err) {
      console.error(err)
    }
  }

  async acceptMerge () {
    try {
      this.setState({merging: true})
      const res = await SostaOnlineApiService.acceptMerge(this.state.user.fiscalCode)
      this.setState({merging: false})
      this.fetchUser()
    } catch (err) {
      this.setState({merging: false})
      console.error(err)
    }
  }

  async denyMerge () {
    try {
      this.setState({merging: true})
      const res = await SostaOnlineApiService.denyMerge(this.state.user.fiscalCode)
      this.setState({merging: false})
      this.fetchUser()
    } catch (err) {
      this.setState({merging: false})
      console.error(err)
    }
  }

  scrollTo (element) {
    scroller.scrollTo(element, {
      duration: 1000,
      delay: 100,
      smooth: true
    })
  }

  highlightElement (element) {
    setTimeout(() => {
      this.setState({
        highlightObjects: [element]
      }, () => {
        setTimeout(() => {
          this.setState({
            highlightObjects: []
          })
        }, 1000)
      })
    }, 1100)
  }

  onVehicleSubmit (data) {
    this.setState({vehicleLoading: true, vehicleError: null, vehicleSuccess: false})
    let obj = {
      userId: this.state.userId,
      plateNumber: data.plateNumber,
      type: data.ownershipType,
      powerSupply: data.powerSupply
    }
    console.log(data, obj)
    SostaOnlineApiService.createVehicle(obj).then(result => {
      this.setState({vehicleLoading: false, vehicleError: null, vehicleSuccess: true})
      this.fetchUser()
    }).catch(err => {
      let error = 'Errore nella creazione del veicolo'
      if (err.error === 'Plate already exists') {
        error = 'Errore! Targa già esistente!'
      }
      this.setState({vehicleLoading: false, vehicleError: error, vehicleSuccess: false})
    })
  }

  onCloseVehicleEdit () {
    this.fetchUser()
    this.setState({vehiclesEditsResults: {}})
  }

  onCloseMarkCease () {
    this.setState({marksCeaseResults: {}})
  }

  onDeleteVehicle (data) {
    let vehiclesDeletes = {}
    vehiclesDeletes[data.id] = 'loading'
    this.setState({vehiclesDeleteResults: vehiclesDeletes})
    SostaOnlineApiService.deleteVehicle(data).then(result => {
      this.setState({vehiclesDeleteResults: {}})
      this.fetchUser()
    }).catch(err => {
      let vehiclesDeletes = {}
      vehiclesDeletes[data.id] = 'error'
      this.setState({vehiclesDeleteResults: vehiclesDeletes})
    })
  }

  onEditVehicleSubmit (data) {
    console.log(data)
    let vehiclesEdits = {}
    vehiclesEdits[data.id] = 'loading'
    this.setState({vehiclesEditsResults: vehiclesEdits})
    let obj = {
      id: data.id,
      plateNumber: data.plate_number,
      type: data.VehicleOwnershipTypeId,
      powerSupply: data.VehiclePowerSupplyId
    }
    SostaOnlineApiService.updateVehicle(obj).then(result => {
      let vehiclesEdits = {}
      vehiclesEdits[data.id] = 'success'
      this.setState({vehiclesEditsResults: vehiclesEdits})
      // this.fetchUser();
    }).catch(err => {
      let vehiclesEdits = {}
      vehiclesEdits[data.id] = 'error'
      this.setState({vehiclesEditsResults: vehiclesEdits})
    })
  }

  async onMarkSubmit (data) {
    this.setState({markLoading: true, markSuccess: false, markError: null})
    let nowMoment = moment()

    // let toOneYearMoment = moment().add(1, 'y').subtract(1, 'days');
    let expirationSetting = await SostaOnlineApiService.fetchSetting('MarkExpirationDate_' + data.markTypeId)
    if (!expirationSetting.data) {
      this.setState({
        markLoading: false,
        markSuccess: false,
        markError: 'Impostazione di scadenza contrassegno non presente nel sistema'
      })
      return
    }
    let expiration = moment(expirationSetting.data.value)
    let vehicles = []

    for (let key in data) {
      if (key.startsWith('vehicle')) {
        vehicles.push(data[key])
      }
    }

    let vehiclesString = ''
    vehicles.map((item, index) => {
      vehiclesString = vehiclesString + item

      if (index < vehicles.length - 1) {
        vehiclesString = vehiclesString + ','
      }
    })

    let obj = {
      method: data.method,
      issuedDate: nowMoment.format(),
      startDate: nowMoment.format(),
      endDate: expiration.format(),
      active: 1,
      userId: parseInt(this.state.userId),
      vehicleIds: vehiclesString,
      startAddressId: data.startAddress,
      addressRoute: data.addressRoute,
      note: data.note,
      quantity: data.quantity,
      markTypeId: parseInt(data.markTypeId),
      categoryId: parseInt(data.categoryId),
      circolazione: data.circolazione,
      periodo: data.periodo,
      sosta: data.sosta,
      color: data.color,
      total: data.total
    }
    SostaOnlineApiService.createMark(obj).then(result => {
      this.setState({markLoading: false, markSuccess: true, markError: null})
      this.fetchUser()
    }).catch(err => {
      let error = 'Errore nella creazione del contrassegno'
      if (err.error === 'Mark already exists') {
        error = 'Errore! Contrassegno già esistente!'
      }
      this.setState({markLoading: false, markSuccess: false, markError: error})
    })
  }

  onDeleteMark (data) {
    let marksDeletes = {}
    marksDeletes[data.id] = 'loading'
    this.setState({marksDeleteResults: marksDeletes})
    SostaOnlineApiService.deleteMark(data).then(result => {
      this.setState({marksDeleteResults: {}})
      this.fetchUser()
    }).catch(err => {
      let marksDeletes = {}
      marksDeletes[data.id] = 'error'
      this.setState({marksDeleteResults: marksDeletes})
    })
  }
  onCeaseMark (data) {
    let marksCease = {}
    marksCease[data.id] = 'loading'
    this.setState({marksCeaseResults: marksCease})
    SostaOnlineApiService.ceaseMark(data).then(result => {
      let marksCease = {}
      marksCease[data.id] = 'success'
      this.setState({marksCeaseResults: marksCease})
      this.fetchUser()
    }).catch(err => {
      let marksCease = {}
      marksCease[data.id] = 'error'
      this.setState({marksCeaseResults: marksCease})
    })
  }

  onParkingPassSubmit (data) {
    let startDateMoment = moment(data.startDate).startOf('month')
    let endDateMoment = moment(data.startDate).add(data.quantity > 1 ? data.quantity - 1 : 0, 'months').endOf('month')
    /* if (data.typeId === '2') {
      endDateMoment = moment(data.startDate).add(6 * data.quantity + (data.quantity - 1), 'days')
      // endDateMoment = moment(data.startDate).add(6, 'days');
    } else {
      endDateMoment = moment(data.startDate).add(29 * data.quantity + (data.quantity - 1), 'days')
      // endDateMoment = moment(data.startDate).add(29, 'days');
    } */

    let vehicles = []

    for (let key in data) {
      if (key.startsWith('vehicle')) {
        vehicles.push(data[key])
      }
    }

    this.setState({parkTicketLoading: true, parkTicketSuccess: false, parkTicketError: null})
    let obj = {
      quantity: data.quantity,
      method: data.method,
      issuedDate: moment().format(),
      startDate: startDateMoment.format(),
      endDate: endDateMoment.format(),
      active: 1,
      userId: parseInt(this.state.userId),
      markId: data.markId ? parseInt(data.markId) : null,
      vehicles: vehicles,
      total: data.total,
      note: data.note,
      markTypeId: data.markTypeId ? parseInt(data.markTypeId) : null,
      categoryId: parseInt(data.categoryId),
      parkTicketTypeId: data.typeId,
      circolazione: data.circolazione,
      periodo: data.periodo,
      sosta: data.sosta,
      color: data.color
    }
    SostaOnlineApiService.createParkTicket(obj).then(result => {
      this.setState({parkTicketLoading: false, parkTicketSuccess: true, parkTicketError: null})
      this.fetchUser()
    }).catch(err => {
      let error = "Errore nella creazione dell'abbonamento"
      if (err.error === 'ParkTicket already exists') {
        error = 'Errore! Abbonamento già esistente!'
      }
      this.setState({parkTicketLoading: false, parkTicketSuccess: false, parkTicketError: error})
    })
  }

  async onCreateMarkUserCategorySelected (category) {
    let cat = this.state.user.categories.filter(item => item.id === parseInt(category.target.value))
    if (cat.length > 0) {
      let area

      if (cat[0].resident) {
        area = this.state.user.residenceArea.code
      } else {
        area = this.state.user.workArea.code
      }

      const markTypes = await SostaOnlineApiService.fetchMarkTypesByCategoryAndArea(cat[0].id, area)
      this.setState({markTypes: markTypes.data, loading: false})
    }
  }

  onEditProfileClick () {
    this.props.history.push('/backoffice/users/' + this.state.userId + '/edit')
  }

  onDownloadParkTicket (parkTicket) {
    SostaOnlineApiService.downloadParkTicket(parkTicket.id).then(data => {
      fileDownload(data, 'abbonamento-' + parkTicket.issuedDate + '.pdf', 'application/pdf')
    })
  }

  onDownloadMark (mark) {
    SostaOnlineApiService.downloadMark(mark.id).then(data => {
      fileDownload(data, 'contrassegno-' + mark.issuedDate + '.pdf', 'application/pdf')
    })
  }

  onDownloadMarkRelease (mark) {
    SostaOnlineApiService.downloadMarkRelease(mark.id).then(data => {
      fileDownload(data, 'modulo-rilascio-contrassegno-' + mark.id + '.pdf', 'application/pdf')
    })
  }

  onDownloadUserCredentials (user) {
    SostaOnlineApiService.downloadUserCredentials(user.id).then(data => {
      fileDownload(data, 'credenziali-utente-' + user.id + '.pdf', 'application/pdf')
    })
  }

  onReceiptDownload (parkTicketId) {
    SostaOnlineApiService.downloadReceipt(parkTicketId).then(data => {
      fileDownload(data, 'ricevuta-' + parkTicketId + '.pdf', 'application/pdf')
    })
  }

  onMarkReceiptDownload (mark) {
    SostaOnlineApiService.downloadMarkReceipt(mark.id).then(data => {
      fileDownload(data, 'ricevuta-contrassegno-' + mark.id + '.pdf', 'application/pdf')
    })
  }

  onIssueReceipt (parkTicket) {
    this.setState({loading: true, error: null, receiptCreateSuccess: false, receiptCreateError: false})
    SostaOnlineApiService.fetchParkTicketType(parkTicket.parkTicketTypeId).then(parkType => {
      SostaOnlineApiService.createReceipt({ method: parkTicket.method, total: parkType.data.price, parkTicketId: parkTicket.id}).then(result => {
        this.setState({error: null, loading: false, receiptCreateSuccess: true, receiptCreateError: false})
        this.fetchUser()
      }).catch(err => {
        this.setState({error: 'Errore nella creazione della ricevuta', loading: false, receiptCreateError: true, receiptCreateSuccess: false})
      })
    })
  }

  async onMarkActivateClick (mark) {
    console.log(mark)
    let nowMoment = moment()
    // let toOneYearMoment = moment().add(1, 'y').subtract(1, 'days');
    // let expiration = moment().month(11).date(31);
    // let expiration = moment('2018-08-31')
    let expirationSetting = await SostaOnlineApiService.fetchSetting('MarkExpirationDate_' + mark.markTypeId)
    let expiration = moment(expirationSetting.data.value)
    this.setState({markLoading: true, markSuccess: false, markError: null})
    let obj = {
      id: mark.id,
      startDate: nowMoment.format(),
      endDate: expiration.format(),
      issuedDate: nowMoment.format(),
      active: 1,
      markTypeId: parseInt(mark.markTypeId),
      categoryId: parseInt(mark.categoryId),
      circolazione: mark.circolazione,
      periodo: mark.periodo,
      sosta: mark.sosta
    }
    SostaOnlineApiService.updateMark(obj).then(result => {
      this.setState({markLoading: false, markSuccess: true, markError: null})
      this.fetchUser()
    }).catch(err => {
      let error = 'Errore nella conferma del contrassegno'
      this.setState({markLoading: false, markSuccess: false, markError: error})
    })
  }

  onDenyMarkActivationClick (reason, mark) {
    if (!reason) {
      return
    }

    console.log(reason, mark)
    this.setState({markLoading: true, markSuccess: false, markError: null})
    let obj = {
      id: mark.id,
      active: 1,
      ceased: 1,
      note: reason
    }
    SostaOnlineApiService.updateMark(obj).then(result => {
      this.setState({markLoading: false, markSuccess: true, markError: null})
      this.fetchUser()
    }).catch(err => {
      let error = 'Errore nel rifiuto del contrassegno'
      this.setState({markLoading: false, markSuccess: false, markError: error})
    })
  }

  async onListAsWaitConfirm (instructions, mark) {
    try {
      if (!instructions) {
        return
      }

      this.setState({markLoading: true, markSuccess: false, markError: null})
      let obj = {
        markId: mark.id,
        notes: instructions
      }
      const response = await SostaOnlineApiService.addMarkNote(obj)
      if (response.result !== 'ok') {
        this.setState({
          markLoading: false,
          marksNotesAddedResults: {[mark.id]: false},
          markError: 'Errore nell\'invio delle istruzioni'
        })
      } else {
        this.setState({
          markLoading: false,
          marksNotesAddedResults: {[mark.id]: true},
          markError: null
        })
      }
      this.fetchUser()
    } catch (e) {
      console.error('errore nell\'invio delle istruzioni', e)
      this.setState({
        markLoading: false,
        marksNotesAddedResults: {[mark.id]: false},
        markError: 'Errore nell\'invio delle istruzioni'
      })
    }
  }

  fetchUser () {
    this.setState({loading: true})
    SostaOnlineApiService.fetchUser(this.state.userId).then((data) => {

      const sortedUser = data.data;
      // console.log( JSON.stringify(sortedUser.marks))
      sortedUser.marks = sortedUser.marks.reverse()
      sortedUser.parkTickets = sortedUser.parkTickets.reverse()

      let user = sortedUser
      let newReviewingMark = null
      if (user.marks.length > 0) {
        user = {
          ...user,
          marks: user.marks.map(item => {
            return (
              {
                ...item,
                documentsReview: this.checkDocumentsApprovation(item)
              }
            )
          })
        }

        if (this.state.reviewingMark) {
          let foundReviewingMarks = user.marks.filter(item => item.id === this.state.reviewingMark.id)
          if (foundReviewingMarks.length > 0) {
            newReviewingMark = foundReviewingMarks[0]
          }
        }
      }

      this.setState({
        user: user,
        reviewingMark: newReviewingMark
        // loading: false
      }, () => {
        if (data.data.fiscalCode) {
          this.fetchRegistry(data.data.fiscalCode)
        }
        this.fetchAdjustment(data.data.fiscalCode, data.data.vatNumber)
        this.fetchMerger(data.data.fiscalCode)
      })
    })
  }

  fetchRegistry (fiscalCode) {
    this.setState({loading: true})
    SostaOnlineApiService.fetchRegistry(fiscalCode).then((data) => {
      this.setState({registry: data.data ? data.data : {}, loading: false})
    })
  }

  fetchUserCompletedWaitingLists = async () => {
    const result = await SostaOnlineApiService.fetchBackofficeMyPartecipationWaitingLists(this.state.userId)
    this.setState({
      userWaitingLists: result.data
    })
  }

  fetchParkTicketTypes () {
    SostaOnlineApiService.fetchParkTicketTypes().then((data) => {
      this.setState({
        parkTicketTypes: data.data,
        loading: false
      })
    })
  }

  fetchAddresses () {
    this.setState({loading: true})
    SostaOnlineApiService.fetchAddresses().then((data) => {
      this.setState({
        addresses: data.data,
        loading: false
      })
    })
  }

  fetchAreas () {
    this.setState({loading: true})
    SostaOnlineApiService.fetchAreas().then((data) => {
      this.setState({
        areas: data.data,
        loading: false
      })
    })
  }

  fetchParkingPassTypes () {
    this.setState({loading: true})
    SostaOnlineApiService.fetchParkingPassTypes().then((data) => {
      this.setState({
        parkingPassTypes: data.data,
        loading: false
      })
    })
  }

  onCloseWaitConfirm () {
    this.setState({
      marksNotesAddedResults: {}
    })
  }

  checkDocumentsApprovation (mark) {
    if (mark.MarkType.DocumentTypes.length === 0) {
      return {
        documents: []
      }
    }

    const documentTypes = []
    let totalDocumentsRequested = 0
    let totalDocumentsUploaded = mark.MarkDocuments.length
    let totalDocumentsApproved = mark.MarkDocuments.filter(item => item.approved).length

    for (let i = 0; i < mark.MarkType.DocumentTypes.length; i++) {
      const documentType = mark.MarkType.DocumentTypes[i]
      const resultObj = {
        ...documentType,
        documents: []
      }
      if (documentType.slug === 'carta_circolazione_veicoli') {
        for (let v = 0; v < mark.Vehicles.length; v++) {
          totalDocumentsRequested++
          const vehicle = mark.Vehicles[v]
          if (vehicle.VehicleDocuments.filter(item => item.DocumentTypeId === documentType.id).length === 0) {
            continue
          }

          for (let vd = 0; vd < vehicle.VehicleDocuments.length; vd++) {
            const vehicleDocument = vehicle.VehicleDocuments[vd]
            if (vehicleDocument.DocumentTypeId === documentType.id) {
              // totalDocumentsUploaded++
              /* if (vehicleDocument.approved) {
                totalDocumentsApproved++
              } */
              resultObj.documents.push({
                vehiclePlateNumber: vehicle.plate_number,
                vehicleId: vehicle.id,
                documentName: vehicleDocument.Document.name,
                documentApproved: vehicleDocument.approved,
                documentId: vehicleDocument.Document.id,
                mimeType: vehicleDocument.Document.mimeType
              })
            }
          }
        }
      } else {
        totalDocumentsRequested++
        for (let d = 0; d < mark.MarkDocuments.length; d++) {
          const document = mark.MarkDocuments[d]
          if (document.DocumentTypeId === documentType.id) {
            // totalDocumentsUploaded++
            /* if (document.approved) {
              // totalDocumentsApproved++
            } */
            resultObj.documents.push({
              documentApproved: document.approved,
              documentId: document.Document.id,
              mimeType: document.Document.mimeType
            })
          }
        }
      }
      documentTypes.push(resultObj)
    }

    return {
      totalDocumentsRequested: totalDocumentsRequested,
      totalDocumentsUploaded: totalDocumentsUploaded,
      totalDocumentsApproved: totalDocumentsApproved,
      documentTypes: documentTypes
    }
  }

  onOpenReviewDocumentsModal (mark) {
    console.log('sono qui', mark)
    this.setState({
      reviewingMark: mark,
      showReviewDocumentsModal: true
    })
  }

  onCloseReviewDocumentsModal () {
    this.setState({
      reviewingMark: null,
      showReviewDocumentsModal: false
    })
  }

  async onApprovationChanged () {
    await this.fetchUser()
  }

  async onMarkEditSubmit (mark) {
    const { submittingMarkEdit } = this.state
    if (submittingMarkEdit) {
      return
    }

    this.setState({ submittingMarkEdit: true })

    console.log(mark)

    const editedMark = {
      id: mark.id,
      vehicles: mark.vehicles.map(item => ({id: item})),
      startAddressId: mark.startAddress + '',
      addressRoute: mark.addressRoute,
      price: mark.total,
      method: mark.method,
      periodo: mark.periodo,
      circolazione: mark.circolazione,
      sosta: mark.sosta
    }

    const response = await SostaOnlineApiService.editMarkBackoffice(editedMark)
    await this.fetchUser()
    this.setState({ submittingMarkEdit: false })
    return response
  }

  onVehicleShortLinkClick = (vehicle) => {
    this.scrollTo(`vehicle-${vehicle.id}`)
    this.highlightElement(`vehicle-${vehicle.id}`)
  }

  onMarkShortLinkClick (mark) {
    this.scrollTo(`mark-${mark.fatherMark}`)
    this.highlightElement(`mark-${mark.fatherMark}`)
  }

  findObjectById (id, objectsArray) {
    const searchResult = objectsArray.filter(item => item.id === id)
    if (searchResult.length > 0) {
      return searchResult[0]
    }

    return null
  }

  async onMarkRenew (mark) {
    this.setState({
      markRenewingErrors: {}
    })

    const {
      renewPaymentMethodSelected
    } = this.state

    if (!renewPaymentMethodSelected) {
      this.setState({
        markRenewingErrors: {[mark.id]: 'Metodo di pagamento obbligatorio'}
      })
    }

    const result = await SostaOnlineApiService.editMarkBackoffice({
      id: mark.id,
      vehicles: mark.Vehicles,
      action: 'RENEW',
      method: renewPaymentMethodSelected
    })

    console.log(result)

    if (result.result === 'ok') {
      this.fetchUser()
      this.setState({
        markRenewingErrors: {},
        markRenewing: {}
      })
    } else {
      this.setState({
        markRenewingErrors: {[mark.id]: 'Errore nella richiesta di rinnovo'}
      })
    }
  }

  onRenewPaymentMethodChange (event) {
    this.setState({
      renewPaymentMethodSelected: event.target.value
    })
  }

  onRenewMarkClick (mark) {
    let markRenewing = {}
    markRenewing[mark.id] = true
    this.setState({markRenewing: markRenewing})
  }

  onCancelRenewMarkClick (mark) {
    this.setState({markRenewing: {}})
  }

  async onAdjustmentPay (method) {
    try {
      const { userAdjustment, user } = this.state
      const response = await SostaOnlineApiService.setAdjustmentPayed(
        userAdjustment.id,
        user.id,
        method
      )
      await this.fetchAdjustment(user.fiscalCode, user.vatNumber)
    } catch (e) {
      console.error(e)
    }
  }

  async onAdjustmentDownloadReceipt () {
    try {
      const { userAdjustment, user } = this.state
      const data = await SostaOnlineApiService.downloadAdjustmentReceipt(userAdjustment.id)
      fileDownload(data, 'ricevuta-pagamento-' + userAdjustment.id + '.pdf', 'application/pdf')
    } catch (e) {
      console.error(e)
    }
  }

  onPayWaitingListParkTicket = async (waitingList, paymentMethod) => {
    try {
      const { userAdjustment, user } = this.state
      const response = await SostaOnlineApiService.approveWaitingListSubscriptionParkTicket(
        waitingList.Subscriptions[0].id,
        user.id,
        paymentMethod
      )
      await this.fetchUserCompletedWaitingLists()
      await this.fetchUser()
    } catch (e) {
      console.error(e)
    }
  }

  render () {
    return (
      <BackOfficeUserDetailScreen
        onDeleteVehicle={this.onDeleteVehicle}
        onVehicleSubmit={this.onVehicleSubmit}
        onCloseVehicleEdit={this.onCloseVehicleEdit}
        onEditVehicleSubmit={this.onEditVehicleSubmit}
        onMarkSubmit={this.onMarkSubmit}
        onDeleteMark={this.onDeleteMark}
        onCeaseMark={this.onCeaseMark}
        onCloseMarkCease={this.onCloseMarkCease}
        onParkingPassSubmit={this.onParkingPassSubmit}
        onCreateMarkUserCategorySelected={this.onCreateMarkUserCategorySelected}
        onDownloadParkTicket={this.onDownloadParkTicket}
        onDownloadMark={this.onDownloadMark}
        onDownloadMarkRelease={this.onDownloadMarkRelease}
        onDownloadUserCredentials={this.onDownloadUserCredentials}
        onReceiptDownload={this.onReceiptDownload}
        onMarkReceiptDownload={this.onMarkReceiptDownload}
        onIssueReceipt={this.onIssueReceipt}
        onEditProfileClick={this.onEditProfileClick}
        onMarkActivateClick={this.onMarkActivateClick}
        onDenyMarkActivationClick={this.onDenyMarkActivationClick}
        onListAsWaitConfirm={this.onListAsWaitConfirm}
        onCloseWaitConfirm={this.onCloseWaitConfirm}
        onOpenReviewDocumentsModal={this.onOpenReviewDocumentsModal}
        onCloseReviewDocumentsModal={this.onCloseReviewDocumentsModal}
        onMarkShortLinkClick={this.onMarkShortLinkClick}
        onVehicleShortLinkClick={this.onVehicleShortLinkClick}
        findObjectById={this.findObjectById}
        onMarkRenew={this.onMarkRenew}
        onRenewPaymentMethodChange={this.onRenewPaymentMethodChange}
        renewPaymentMethodSelected={this.state.renewPaymentMethodSelected}
        parkingPassTypes={this.state.parkingPassTypes}
        parkTicketTypes={this.state.parkTicketTypes}
        userAdjustment={this.state.userAdjustment}
        user={this.state.user}
        addresses={this.state.addresses}
        areas={this.state.areas}
        userTypes={this.state.userTypes}
        markTypes={this.state.markTypes}
        userType={this.state.userType}
        vehicleLoading={this.state.vehicleLoading}
        vehicleSuccess={this.state.vehicleSuccess}
        vehicleError={this.state.vehicleError}
        markLoading={this.state.markLoading}
        markSuccess={this.state.markSuccess}
        markError={this.state.markError}
        parkTicketLoading={this.state.parkTicketLoading}
        parkTicketSuccess={this.state.parkTicketSuccess}
        parkTicketError={this.state.parkTicketError}
        receiptLoading={this.state.receiptLoading}
        receiptSuccess={this.state.receiptSuccess}
        receiptError={this.state.receiptError}
        vehiclesEditsResults={this.state.vehiclesEditsResults}
        vehiclesDeleteResults={this.state.vehiclesDeleteResults}
        markDeleteResults={this.state.marksDeleteResults}
        markActivateErrors={this.state.markActivateErrors}
        markCeaseResults={this.state.marksCeaseResults}
        marksNotesAddedResults={this.state.marksNotesAddedResults}
        registry={this.state.registry}
        showReviewDocumentsModal={this.state.showReviewDocumentsModal}
        reviewingMark={this.state.reviewingMark}
        highlightObjects={this.state.highlightObjects}
        onApprovationChanged={this.onApprovationChanged}
        onMarkEditSubmit={this.onMarkEditSubmit}
        onCancelRenewMarkClick={this.onCancelRenewMarkClick}
        onRenewMarkClick={this.onRenewMarkClick}
        markRenewing={this.state.markRenewing}
        markRenewingErrors={this.state.markRenewingErrors}
        onAdjustmentDownloadReceipt={this.onAdjustmentDownloadReceipt}
        onAdjustmentPay={this.onAdjustmentPay}
        merger={this.state.merger}
        acceptMerge={this.acceptMerge}
        denyMerge={this.denyMerge}
        merging={this.state.merging}
        userWaitingLists={this.state.userWaitingLists}
        onPayWaitingListParkTicket={this.onPayWaitingListParkTicket}
      />
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(BackOfficeUserDetailContainer)



// WEBPACK FOOTER //
// ./src/containers/BackOfficeUserDetailContainer.js